var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5953_92129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.16 7.14581C13.16 6.69081 13.1192 6.25331 13.0433 5.83331H7V8.31831H10.4533C10.3017 9.11748 9.84667 9.79415 9.16417 10.2491V11.865H11.2467C12.46 10.745 13.16 9.09998 13.16 7.14581Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99982 13.4166C8.73232 13.4166 10.1848 12.845 11.2465 11.865L9.16398 10.2491C8.59232 10.6341 7.86315 10.8675 6.99982 10.8675C5.33148 10.8675 3.91398 9.74164 3.40648 8.22498H1.27148V9.88164C2.32732 11.9758 4.49148 13.4166 6.99982 13.4166Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40683 8.21915C3.2785 7.83415 3.20266 7.42581 3.20266 6.99998C3.20266 6.57415 3.2785 6.16581 3.40683 5.78081V4.12415H1.27183C0.834329 4.98748 0.583496 5.96165 0.583496 6.99998C0.583496 8.03831 0.834329 9.01248 1.27183 9.87581L2.93433 8.58081L3.40683 8.21915Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99982 3.13831C7.94482 3.13831 8.78482 3.46498 9.45565 4.09498L11.2932 2.25748C10.179 1.21915 8.73232 0.583313 6.99982 0.583313C4.49148 0.583313 2.32732 2.02415 1.27148 4.12415L3.40648 5.78081C3.91398 4.26415 5.33148 3.13831 6.99982 3.13831Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5953_92129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Google.11665440a6d2e38f1007473fce0cc54d.svg";